import { Chip, type ChipProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { CaseStatus } from "src/types";
import { caseStatusBackgroundColor, caseStatusTextColor } from "src/utils/case.utils";

type CaseStatusChipProps = ChipProps & {
  status: CaseStatus;
};

export const CaseStatusChip = styled(Chip, {
  shouldForwardProp: (prop) => prop !== "status",
})<CaseStatusChipProps>`
  background-color: ${({ status }) => caseStatusBackgroundColor(status)};
  color: ${({ status }) => caseStatusTextColor(status)};
`;
